module.exports = __webpack_public_path__ + "img/placeholder-image.873c1675.png";